import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '../services/app-config.service';
import { SessionService } from '../services/session.service';

@Injectable()
export class BearerTokenInterceptor implements HttpInterceptor {
    constructor(
        private sessionService: SessionService,
        private appConfigService: AppConfigService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.sessionService.isAuthenticated() && request.url.startsWith(this.appConfigService.getConfig().apiUrl)) {
            request = request.clone({
                setHeaders: { Authorization: `Bearer ${this.sessionService.getBearerToken()}` }
            });
        }

        return next.handle(request);
    }
}
